import { ITokenStorage, SDK } from "@axl-dev/school-sdk";
import { createContext, FC, PropsWithChildren, useMemo } from "react";

import { useSettings } from "@app/shared/lib/hooks";

import { CookieTokenStorage } from "./token-storage";
import { useLangDetector } from "./hooks/useLangDetector";

interface SdkContextType {
  sdk: SDK;
  tokenStorage: ITokenStorage;
}

export const SdkContext = createContext({} as SdkContextType);

export const SdkProvider: FC<PropsWithChildren> = ({ children }) => {
  const settings = useSettings();
  const langDetector = useLangDetector();
  const tokenStorage = useMemo<ITokenStorage>(() => new CookieTokenStorage(), []);

  const sdk = useMemo(
    () => ({
      tokenStorage,
      sdk: new SDK(tokenStorage, {
        schoolDomain:
          import.meta.env.VITE_APP_SCHOOL_DOMAIN === "ORIGIN"
            ? window.location.origin
            : import.meta.env.VITE_APP_SCHOOL_DOMAIN,
        chat: {
          clientConfig: {
            host: settings.chat.hubUrl,
            invokeTimeoutMs: 10000,
          },
        },
        hub: {
          clientConfig: {
            host: settings.hub.url,
            invokeTimeoutMs: 10000,
          },
        },
        lang: langDetector.autoLang
      }),
    }),
    [settings.chat.hubUrl, settings.hub.url, tokenStorage],
  );

  return <SdkContext.Provider value={sdk}>{children}</SdkContext.Provider>;
};
